export async function safeFetch(url, options = {}) {
  // Mantém tudo exatamente como já está
  const controller = new AbortController();
  const timeout = options.timeout || 15000; // 15s bem conservador

  const id = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      credentials: options.credentials ?? 'include', // só adiciona
      headers: options.headers // NÃO toca nos headers existentes
    });

    return response; // 🔴 não muda fluxo atual
  } catch (err) {
    if (err.name === 'AbortError') {
      console.error('[safeFetch] timeout', url);
    } else {
      console.error('[safeFetch] error', err);
    }
    throw err; // mantém comportamento original
  } finally {
    clearTimeout(id);
  }
}
